import { defineStore } from 'pinia';
import type { DialogStateModel } from '~/common/models/store.dialog.model.ts';

export const useDialogStore = defineStore('kegel', {
  state: (): DialogStateModel => {
    return {
      componentName: null,
      componentProps: {},
      showDialog: false,
    };
  },
});
